import {Base} from "@/api/Base"

export class AttendanceLogsEdit extends Base {
    path = "attendanceLogs/edit"
}